import { useEffect, useRef } from 'react';
import { swallowNextEscapeKeyUp } from '../Modal/swallowEscapeKeyUp';
/**
 * Popups (pickers, dropdowns) close on the Escape keydown, but a host Brushaway closes on the keyup of the same
 * press, so one Escape closed both. While a popup is open, the Escape keydown is the popup's alone: it is stopped
 * in the capture phase, its keyup is swallowed (as Modal does), and only the most recently opened popup closes,
 * so a picker inside a Popup closes before the Popup does.
 */
const openPopups = [];
function handleKeyDown(event) {
    const top = openPopups[openPopups.length - 1];
    if (event.key !== 'Escape' || !top)
        return;
    event.stopPropagation();
    swallowNextEscapeKeyUp();
    top.close();
}
export function useCloseOnEscape(open, onClose) {
    const onCloseRef = useRef(onClose);
    onCloseRef.current = onClose;
    useEffect(() => {
        if (!open)
            return undefined;
        const entry = { close: () => onCloseRef.current() };
        if (openPopups.length === 0)
            window.addEventListener('keydown', handleKeyDown, true);
        openPopups.push(entry);
        return () => {
            openPopups.splice(openPopups.indexOf(entry), 1);
            if (openPopups.length === 0)
                window.removeEventListener('keydown', handleKeyDown, true);
        };
    }, [open]);
}
